import React, { useEffect, useState } from 'react';
import config from '../config/index';
import axios from 'axios';
import { Redirect } from 'react-router-dom'
import Loading from './loading'
import UseStore from '../store/store';

export default function Auth(){
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [loading, setLoading] = useState(true)

    const { mpUser, setMpUser } = UseStore()

    useEffect(() =>{
        const pageUrl = new URL(window.location.href)
        const searchParams = new URLSearchParams(pageUrl.search)
        const accessToken = searchParams.get('accessToken');

        if(accessToken !== undefined || accessToken !== null){
            axios.post(config.userDetails, 
                {authServerAccessToken: accessToken,
                 isSSOLogin: true
            })
                .then((response) =>{
                    if (response.data.isSuccess === true) {
                        response.data.user.accessToken=accessToken
                        setMpUser(response.data.user)
                        setIsLoggedIn(true)
                    }
                    else{
                        setIsLoggedIn(false)
                    }
                    setLoading(false)
                })
                .catch(e => {
                    console.error(e)
                })
                
        }
        else {
            setLoading(false)
        }
    },[])

    if(isLoggedIn === true && loading === false){
        console.log(mpUser)
        return(
            <Redirect to="/chat"/>
        )
    }
    else if(isLoggedIn === false && loading === false){
        return(
            <Redirect to="/401"/>
        )
    }
    else if(loading === true){
        return(
            <Loading />
        )
    }
}